import React, { useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import Summary from './Summary';
import TransferDetails from './TransferDetails';
import Attempts from './Attempts';

import RawData from 'components/RawData';
import Loader from 'components/Loader';
import DashboardContainer from 'components/DashboardContainer';
import BreadCrumbs from 'components/BreadCrumbs';
import WebhookTable from 'pages/Webhooks/WebhookTable';

import { transferDetails as TEXT } from 'locales/en/transfer';
import { transferByIdSelector } from 'redux/slices/transfer';
import { getTransfersById, getTransferWebhooks } from 'redux/slices/transfer';
import { usePrevious } from 'hooks';

const TransferDetail = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const prevId = usePrevious(id);

  const { data: transfer, isLoading } = useSelector((state) =>
    transferByIdSelector(state, id)
  );
  const isDevOrSuperAdmin = useSelector(
    (state) => state.auth.user.isDevOrSuperAdmin
  );
  useEffect(() => {
    if (!isLoading) {
      dispatch(getTransfersById(id));
    }
    dispatch(getTransferWebhooks({ transfer_id: id }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!!prevId && prevId !== id) {
      dispatch(getTransfersById(id));
      dispatch(getTransferWebhooks({ transfer_id: id }));
    }
  }, [dispatch, id, prevId]);

  const onWebhookPageChange = ({ selected }) => {
    return dispatch(
      getTransferWebhooks({ transfer_id: id, page: selected + 1 })
    );
  };

  const rawJSON = useMemo(() => {
    return JSON.stringify(transfer?.error, null, 2);
  }, [transfer]);

  return (
    <>
      <BreadCrumbs screen="transfer" />
      {isLoading && <Loader />}
      {!!transfer ? (
        <DashboardContainer header={`${TEXT.header1} ${id}`}>
          <Summary transfer={transfer} />
          <TransferDetails transfer={transfer} />
          <Attempts transfer={transfer} />
          <RawData json={rawJSON} title={TEXT.errorHeader} />
          {!!transfer.webhooks?.data?.length && isDevOrSuperAdmin && (
            <WebhookTable
              isDetail
              title={TEXT.webhookHeader}
              data={transfer.webhooks.data}
              pagination={transfer.webhooks.pagination}
              onPageChange={onWebhookPageChange}
            />
          )}
        </DashboardContainer>
      ) : null}
    </>
  );
};

export default TransferDetail;
